import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { FooterComponent } from '../footer/footer.component';
import { HeaderComponent } from "../header/header.component";
import { FormsModule } from '@angular/forms';
@Component({
  selector: 'app-pagalo-pe',
  imports: [FooterComponent, HeaderComponent, FormsModule],
  templateUrl: './pagalo-pe.component.html',
  styleUrl: './pagalo-pe.component.css'
})
export class PagaloPeComponent implements OnInit {
  constructor(private titleService: Title) { }
  ngOnInit(): void {
    this.titleService.setTitle("pagalo-pe")
  }

  cites = [
    { codigo: '0001', nombre: 'CITE Forestal Pucallpa' },
    { codigo: '0002', nombre: 'CITEagroindustrial - Ica' },
    { codigo: '0003', nombre: 'CITEagroindustrial - Ica - UT Huaura' },
    { codigo: '0004', nombre: 'CITEccal - Lima (Rimac)' },
    { codigo: '0005', nombre: 'CITEpesquero - Piura' },
    { codigo: '0006', nombre: 'CITEmadera - Lima (V.E.S)' },
    { codigo: '0007', nombre: 'CITEagroindustrial - Chavimochic' },
    { codigo: '0010', nombre: 'CITEagroindustrial - Huallaga' },
    { codigo: '0011', nombre: 'CITEccal - Trujillo' },
    { codigo: '0012', nombre: 'CITEccal - Arequipa' },
    { codigo: '0013', nombre: 'CITEproductivo - Maynas' },
    { codigo: '0015', nombre: 'CITEpesquero - Callao' },
    { codigo: '0016', nombre: 'CITEagroindustrial - Majes' },
    { codigo: '0017', nombre: 'CITEagroindustrial - Moquegua' },
    { codigo: '0018', nombre: 'CITEpesquero Amazonico - Pucallpa' },
    { codigo: '0019', nombre: 'CITEtextil Camelidos - Arequipa' },
    { codigo: '0020', nombre: 'CITEagroindustrial - Oxapampa' },
    { codigo: '0022', nombre: 'CITEproductivo - Madre de Dios' },
    { codigo: '0023', nombre: 'CITEproductivo VRAEM' },
    { codigo: '0024', nombre: 'CITEpesquero - Ilo' },
    { codigo: '0026', nombre: 'CITEforestal - Maynas' },
    { codigo: '0027', nombre: 'UT agroindustrial Ambo' },
    { codigo: '0028', nombre: 'CITEtextil Camelidos - Cusco' },
    { codigo: '0029', nombre: 'CITEtextil Camelidos - Puno' },
    { codigo: '0030', nombre: 'CITEmadera - UT Cajamarca' },
    { codigo: '0031', nombre: 'UT Acuicola Pesquero Huancavelica' },
    { codigo: '0032', nombre: 'CITEacuicola productivo San Martin' },
    { codigo: '0033', nombre: 'UT Textil y Confecciones Lima' },
    { codigo: '0034', nombre: 'CITEacuícola - Puno' },
    { codigo: '0035', nombre: 'UT Cuero y Calzado - Junín' },
    { codigo: '0036', nombre: 'UT Agroindustrial Lambayeque - Chavimochic' },
    { codigo: '0037', nombre: 'UT Agroindustrial Ayacucho' },
    { codigo: '0038', nombre: 'UT Agroindustrial Tacna' },
    { codigo: '0039', nombre: 'CITE textil camélidos Huancavelica' }
  ];

copiarCodigo(codigo: string, event: MouseEvent) {
  navigator.clipboard.writeText(codigo);
  
  const tooltip = document.createElement('div');
  tooltip.textContent = '¡Copiado!';
  tooltip.style.cssText = 'position: absolute; background: rgba(0, 0, 0, 0.8); color: white; padding: 5px 10px; border-radius: 4px; font-size: 12px; z-index: 9999';
  tooltip.style.left = event.pageX + 'px';
  tooltip.style.top = (event.pageY - 30) + 'px';
  document.body.appendChild(tooltip);
  
  setTimeout(() => tooltip.remove(), 1500);
}


  buscar = '';

  get citesFiltrados() {
    if (!this.buscar) return this.cites;
    return this.cites.filter(cite =>
      cite.codigo.toLowerCase().includes(this.buscar.toLowerCase()) ||
      cite.nombre.toLowerCase().includes(this.buscar.toLowerCase())
    );
  }

}
